import { ROTULO_CENTRO_DE_CUSTO, type ResumoFinanceiro } from '@arena/shared/schemas';
import { nomeDoMes } from '../planos/formatos.js';
import { Card, Tabela, Tag, Vazio } from '../ui/primitivos.jsx';
import { centrosComMovimento, comSinal, corDoResultado } from './formatos.js';

/**
 * "Resultado por centro de custo": entradas, saídas e a diferença de cada
 * centro no mês — só o REALIZADO, já líquido de estorno.
 *
 * Os números vêm prontos do servidor, calculados sobre as linhas que o
 * perfil alcança: para a Gestão, a folha não está em centro nenhum. A tela
 * só esconde o centro em que não houve movimento e formata; nunca soma.
 */
export function CardDeResultadoPorCentro({ resumo }: { resumo: ResumoFinanceiro }) {
  const centros = centrosComMovimento(resumo.porCentro);

  return (
    <Card titulo="Resultado por centro de custo" dica={`${nomeDoMes(resumo.mes)} · só o realizado`}>
      {centros.length === 0 ? (
        <Vazio>Nenhum movimento realizado neste mês.</Vazio>
      ) : (
        <Tabela colunas={['Centro de custo', 'Entradas', 'Saídas', 'Resultado']}>
          {centros.map((centro) => (
            <tr key={centro.centroDeCusto}>
              <td>
                <Tag>{ROTULO_CENTRO_DE_CUSTO[centro.centroDeCusto]}</Tag>
              </td>
              <td className="num">{comSinal(centro.entradas)}</td>
              <td className="num">{comSinal(centro.saidas)}</td>
              <td
                className="num"
                style={{ color: corDoResultado(centro.resultado), fontWeight: 600 }}
              >
                {comSinal(centro.resultado)}
              </td>
            </tr>
          ))}
        </Tabela>
      )}
    </Card>
  );
}
